export class SubscriptionPlan {
  public id?: number;
  public cost?: number;
  public description?: string;
  public isActive?: boolean;
  public dateCreated?: Date;
  public dateUpdated?: Date;
  public dbRowVersion?: string;
}
